// extracted by mini-css-extract-plugin
module.exports = {"message":"RemoveQueueItemsModal-message-JrJgJ"};